export default {
    'PaymentChatcomponent.Pay to ': 'Pagar a ',

    'Formulary.SENT (to collect)': 'ENVIAT (per cobrar)',
    'Formulary.RECEIVED (to pay)': 'REBUT (per pagar)',
    'Formulary.You cannot post an invoice where you have to pay': 'No pots publicar una factura on has de pagar',

    'Create.day': 'dia',

    'SuggestedFactoringItem.Email ': 'Correu electrònic ',

    'Faucet.AlreadySent': 'Ja s\'ha enviat avui els diners',

    'ByppaySummary.Bypay Summary': 'Resum del Byppay',
    'ByppaySummary,CERTIFICATE': 'CERTIFICAT',
    'ByppaySummary.The Bypay has been approved for everyone:': 'El byppay ha estat aprovat per tothom:',
    'ByppaySummary.PAYER INVOICE': 'FACTURA DEL PAGADOR',

    'FactoringInformation.Factoring information': 'Dades del Byppay',

    'finishCompensation.payerFinish': '{payerCif} paga {amount} € a {receiverCif} al compte {accountNumber}, rep un descompte de {discount}.',
    'finishCompensation.payerPartial': '{payerCif} paga {amount} € a {receiverCif} al compte {accountNumber}, rep un descompte de {discount}€ i pendent pagar {outstandingAmount}€ a {oldReceiverCif}.',
    'finishCompensation.receiverFinish': 'Heu de rebre {amount} € de {receiverCif} al compte {accountNumber}.\n He rebut una bonificació de {bonus}',
    'finishCompensation.receiverPartial': 'Heu de rebre {amount} € de {receiverCif} al compte {accountNumber},pendent de rebre {outstandingAmount} de {payerCif}.\n He rebut una bonificació de {bonus}',
    'finishCompensation.middlePayer': '{payerCif} pagarà directament a {receiverCif} , encara heu de pagar una quantitat de {outstandingAmount} a {receiverCif}',
    'finishCompensation.middleReceiver': '{payerCif} pagarà directament a {receiverCif} , encara heu de rebre {outstandingAmount} de {payerCif}',
    'certificate.middle': 'B reconeix que A emprarà els recursos de la factura AB [{invoiceNumberAB} - ',
    'certificate.middleP2': 'fins a {amount} euro per pagar a C',
    'certificate.middle2': '] que s\'anota amb la compensació',
    'certificate.receiver': 'C reconeix que amb aquest pagament d\'A es compensa {amount} euro de la factura [{invoiceNumberBC} - ',
    'certificate.receiverP2': 'i rep {amount} euro com a interessos de demora',
    'certificate.receiver2': '], que s\'anota d\'aquesta manera ',
    'certificate.payer': 'A reconeix que amb aquest pagament rep un descompte per byppay de {amount} euro/s inclòs en la compensació AB.',
    'certificate.outstanding': 'B reconeix que faltarà per pagar {amount} de la factura {invoiceName}',

    'payment.payiedto': 'He pagat a {user}',
    'payment.receivedFrom': 'He rebut el pagament de\'n  {user}',
    'Payment accepted': 'pagament acceptat',
    'Payment received': 'Pagament rebut',
    'payment.confirmPaymentto': 'Confirma el pagament de {user}.',
    'payment.waitingConfirmationto': 'Esperant {user} que confirmi el pagament.',
    'payment.acceptPaymentFrom': '{user} ha acceptat el pagament.',
    'payment.waitingPaymentFrom': 'Esperant {user} per pagar.',
    'payment.confirmPaymentFrom': 'Confirma el pagament de {user}.',
    'payment.acceptPayment': 'Has acceptat el pagament.',
    'Payment.crypto': 'Pagar amb crypto a ',

    'ImageInvoice.Value': 'Valor',
    'ImageInvoice.Provider NIF/CIF': 'CIF/NIF del proveïdor',
    'ImageInvoice.Client NIF/CIF': 'CIF/NIF del client',
    'ImageInvoice.Invoice Update Successfully': 'Factura penjada correctament',
    'ImageInvoice.Invoice Date': 'Data de la Factura',
    'ImageInvoice.Save Invoice': 'GUARDAR FACTURA',
    'ImageInvoice.You cannot use this option due not have a camera device. Use Custom Upload instead!': 'No pots utilitzar aquesta opció perquè no disposes d’un dispositiu de càmera. En el seu lloc utilitza la càrrega personalitzada!',
    'ImageInvoice.Retry': 'Tornar',
    'ImageInvoice.UPLOAD': 'PUJAR',

    'ListInvoicesForCompensate.Candidate invoice for the Forward:': 'Factures candidates pel Forward',

    'ListInvoices.Provider': 'Proveïdor',
    'ListInvoices.Receiver email:': 'Correu electrònic del receptor',
    'ListInvoices.Have to be a number': 'Ha de ser un número',

    'InvoiceView.Invoice not found': 'Factura no trobada',
    'InvoiceView.Do you want to cancel this bypay?': 'Estàs segur que vols cancel·lar aquest byppay',
    'InvoiceView.ERROR: Non-editable invoice': 'Factura no editable',
    'InvoiceView.Invalid status change': 'Canvi d\'estat d\'usuari no vàlid',
    'InvoiceView.Return amount': 'Quantitat a retornar',
    'InvoiceView.Fullscreen': 'Pantalla completa',

    'Factoring.I ': 'He ',
    'Factoring.accepted the Byppay!': 'acceptat el Byppay!',
    'Factoring.The final state of the bypay is:': 'L\'estat final del Byppay és:',
    'Factoring.rejected the Byppay!': 'rebutjat el Byppay',
    'Factoring.Summary': 'Resum',
    'Factoring.Waiting': 'Esperant',
    'Factoring.Do you want to reject this bypay?': 'Vol esborrar aquest byppay?',

    'RemindOptions.Notify Via...': 'Notificar Via...',
    'RemindOptions.If necessary, enter the phone number to send a SMS notification.': 'Si fos necessari, entra el número de telefon per enviar una notificació via SMS.',
    'RemindOptions.If necessary, enter the phone number to send a Whatsapp notification.': 'Si fos necessari, entra el número de telefon per enviar una notificació via Whatsapp.',
    'RemindOptions.Reminded successfully': 'Recordat satisfactòriament',

    'LandingPage.KNOW MORE': 'SABER-NE MÉS',
    'LandingPage.WHAT IS BYPPAY?': 'QUÈ ÉS BYPPAY?',
    'LandingPage.Upload your invoices': 'Puja les teves factures',
    'LandingPage.Choose which of the invoices your customers will pay your providers': 'Tria quines de les factures dels teus clients pagaran als teus proveïdors',
    'LandingPage.Once accepted, you will get your certificate': 'Un cop acceptat, obtindràs el teu certificat',
    'LandingPage.Check your compensations': 'Consulta les teves compensacions',
    'LandingPage.WHY BYPPAY?': 'PER QUÈ BYPPAY?',
    'LandingPage.FAST': 'RÀPID',
    'LandingPage.Thanks to its BlockChain technology, Bypay allows you to create in a few hours a direct payment agreement between customers and providers': 'Gràcies a la seva tecnologia BlockChain, Byppay permet crear en pocs minuts un acord de pagament directe entre clients i proveïdors',
    'LandingPage.ECONOMIC': 'ECONÒMIC',
    'LandingPage.Byppay avoids the consequences of being an intermediary between customer and provider. Byppay does not depend on any bank': 'Byppay evita les conseqüències de ser intermediari entre client i proveïdor. Byppay no depèn de cap banc',
    'LandingPage.SAFE': 'SEGUR',
    'LandingPage.Bypay uses DLT technology to secure payment agreements between customer-provider.': 'Byppay utilitza tecnologia DLT per assegurar els acords de pagaments entre client-proveïdor.',

    'LandingAC. is a digital system that makes it easier for all those entrepreneurs to pay their providers through potential clients in times of crisis in a fast, cheap and safe way.': 'Byppay és un sistema digital que facilita a tots aquells empresaris a pagar a temps als seus proveïdors a través dels clients potencials en temps de crisis de manera ràpida, barata i segura.',

    'MoreInfo.Upload the invoice to be paid to the web-app': 'Penja la factura a pagar a l\'app-web',
    'MoreInfo.HOW IT WORKS?': 'COM FUNCIONA?',
    'MoreInfo.Request payment of the invoice to the customer you want': 'Sol·licita el pagament de la factura al client que desitgis',
    'MoreInfo.The app automatically negotiates a customer-provider agreement': 'L\'aplicació negocia automàticament un acord client-proveïdor',
    'MoreInfo.You will receive a payment confirmation when the provider has paid the customer, as well as a certificate proving payment': 'Rebràs una confirmació de pagament quan el proveïdor hagi pagat al client, així com un certificat que acrediti el pagament',
    'MoreInfo.is a digital platform that works worldwide and is VAT neutral. It allows you not to advance money to your provider without having received your client\'s income. These payments they are registered with DLT (Distribution Ledger Technology) which makes a valid and secure agreement possible.': 'és una plataforma digital que funciona a tot el món i que no té IVA. Permet no avançar diners al vostre proveïdor sense haver rebut els ingressos del vostre client. Aquests pagaments es registren a una Blockchain, cosa que fa possible un acord vàlid i segur.',
    'MoreInfo.It is a financial solution that works with Ethereum which makes it a DeFi (Decentralized Finance) solution. By the end of 2021, more than 100,000 European SMEs will avoid bills thanks to the digitization of agreements and payments with DeFi solutions such as': 'És una solució financera que funciona amb Ethereum, cosa que el converteix en una solució DeFi (finançament descentralitzat). A finals del 2024, més de 100.000 pimes europees evitaran les factures gràcies a la digitalització d’acords i pagaments amb solucions DeFi com ara',
    'MoreInfo.An invoice is a commercial document that indicates the sale of a good or service and that, among other things, must include all the information of the operation. It has legal and fiscal validity. We can say that it is an accreditation of a transfer of a product or service after purchasing it.': 'Una factura és un document comercial que indica la venda d\'un bé o servei i que, entre altres coses, ha d\'incloure tota la informació de l\'operació. Té validesa legal i fiscal. Podem dir que es tracta d’una acreditació d’una transferència d’un producte o servei després de comprar-lo',
    'MoreInfo.What is an invoice?': 'Què és una factura?',
    'MoreInfo.What is a byppay?': 'Què és un byppay?',
    'MoreInfo.Through the bypay mechanism, a company can pay the invoices to its suppliers with the invoices of its clients.': 'Mitjançant el mecanisme de byppay, una empresa pot pagar les factures als seus proveïdors amb les factures dels seus clients',
    'MoreInfo.It is the reverse procedure to bypay, through which a company invoices from clients (to be collected) can be sent to our suppliers to pay their invoices.': 'És el procediment invers al byppay, mitjançant el qual es poden enviar les factures d\'una empresa als clients (que s\'han de cobrar) als nostres proveïdors per pagar les seves factures',
    'MoreInfo.The main benefit that the company obtains when executing this operation is to offset invoices. This, by extension, improves the financing capacity of the business.': 'El principal avantatge que obté l\'empresa en executar aquesta operació és compensar les factures. Això, per extensió, millora la capacitat de finançament del negoci',
    'MoreInfo.It is the technology that ensures that the actions related to a bypay / factoring are registered without the possibility of being altered in the future. Certify the validity of the process.': 'És la tecnologia que garanteix que les accions relacionades amb un byppay es registrin sense la possibilitat de ser alterades en el futur. Certifica la validesa del procés.',
    'MoreInfo.FAST, CHEAP & SAFE': 'RÀPID, ECONÒMIC I SEGUR',
    'MoreInfo.You pay your invoices by bypaying income directly to your providers. No cash, no funding are needed. The app uses DLT/Blockchain to secure the byppay agreements': 'Pagueu les factures amb els vostres ingressos directament als proveïdors. No cal efectiu, no es necessita finançament. L\'aplicació utilitza DLT / Blockchain per protegir els acords de byppay',
    'MoreInfo.HOW DOES IT WORK?': 'COM FUNCIONA?',
    'MoreInfo.Upload your providers and clients invoices into the app. The app will propose byppaying some invoices: When your clients pay directly to your providers, you have paid then indeed, and invoices compensated!': 'Pengeu les factures dels proveïdors i dels clients a l\'aplicació. L\'aplicació proposarà fer byppay d\'algunes factures: quan els vostres clients paguen directament als vostres proveïdors, ja heu pagat i les factures s\'han compensat.',
    'MoreInfo.A NEW NORMAL': 'UNA NOVA NORMALITAT',
    'MoreInfo.Byppaying is the fastest, cheapest and safest funding in the market.': 'El byppay és el finançament més ràpid, més barat i més segur del mercat',

    'ByppayList.No bypay has yet been initiated with this invoice.': 'Encara no s\'ha iniciat cap byppay amb aquesta factura.',

    'ItemListChat.REMAIN': "FALTANT",

    'AdminCommissions.Receiver comission': 'Interés de demora pel Proveïdor',
    'AdminCommissions.Platform comission': 'Comissió de la plataforma',
    'AdminCommissions.Byppay Commision': 'Descompte pel Client',

    'CollateralModal.Add to list': 'Afegit a la llista',
    'CollateralModal.Minimum value to pay': 'Minim valor a pagar: ',
    'CollateralModal.Email list notification': 'Llistat de correus a qui notificar la publicació al mercat. Els correus estaran separats per comes.',
    'Collateralmodal.MessagePublish': 'Per poder publicar al marketplace fa falta pagar com a mínim un {percentage} % de la factura ',

    'CollateralView.Anonymous': 'Anònim',

    'AcceptBypayes.Approve byppayes': 'Aprovar byppayes',

    'NavigationMenu.Invoices to pay': 'Factures a pagar',
    'NavigationMenu.Invoices to be payed': 'Factures a cobrar',
    'NavigationMenu.Clients': 'Clients',
    'NavigationMenu.Marketplace': 'Marketplace',
    'NavigationMenu.AMM': 'AMM',
    'NavigationMenu.Faq': 'Preguntes Freqüents',
    'NavigationMenu.Chat': 'Xat',

    'MainView.Min Date': 'Data Mínima',
    'MainView.Min-Max Amount': 'Quantitat Min-Max',
    'MainView.Introduce Min and Max Date': 'Introdueix la Data Mínima i/o Màxima',
    'MainView.To get paid': 'Rebre',
    'MainView.Error listing invoices': 'Error al llistat de factures',
    'Mainview.There are no invoices yet': 'Encara no tens cap factura',
    'MainView.Failed': 'Fracassat',
    'MainView.Advanced Options': 'Opcions avançades',
    'MainView.Reset': 'Restablir',
    'MainView.Filter': 'Filtrar',
    'MainView.Archived': 'Arxivat',

    'InvoiceChats.No messages in chat': 'No hi ha missatges en aquest chat',
    'InvoiceChats.My chats': 'Els meus chats',

    'AcceptBypaymentChatComponent.Decline': 'Reject',

    'VideoInput.Record Video': 'Gravar Video',

    'ItemListChat.Receive': 'Rebre',
    'ItemListChat.Invited': 'Invitat',

    'InviteChatForm.Send MAIL': 'Enviar EMAIL',
    'InviteChatForm.Send SMS': 'Enviar SMS',
    'InviteChatForm.Send Whatsapp': 'Enviar Whatsapp',
    'InviteChatForm.InviteEmail': 'Convidar per email',
    'InviteChatForm.InvitePhone': 'Convidar per mòvil',

    'AddInvoiceToChat.AddInvoice': 'Afegeix factura al xat',

    'Invoice': 'Factura',
    'ItemMessageFormInvite.Invite': 'Invitar',
    'AllFilesChat.with': 'amb',
    'chat.newChat': 'Missatge benvinguda',
    'chat.newChatExtra': 'A continuació es mostra el vídeo de benvinguda i un enllaç amb els primers passos a seguir',
    'chat.remindInvite': 'Recordatori invitació',

    'chat.inviteDownStream': '{user} ha convidat {userInvited}. Esperant que {userInvited} accepti',
    'chat.inviteDownStreamExtra': '{userInvited} ha d\'acceptar la invitació i unir-se al xat. \n En cas de no acceptar pots enviar un recordatori d\'unir-se al xat',
    'chat.inviteUpStream': '{user} ha convidat {userInvited}. Esperant que {userInvited} accepti (byppay)',
    'chat.inviteUpStreamExtra': '{userInvited} ha d\'acceptar la invitació i unir-se al xat. \n En cas de no acceptar pots enviar un recordatori d\'unir-se al xat',

    'chat.enterDownStream': '{user} ha entrat en el chat (invoice)',
    'chat.enterDownStreamExtra': '{payerUser} ha d\'afegir la factura de {user}',
    'chat.enterUpStream': '{user} ha entrat en el chat (byppay)',
    'chat.enterUpStreamExtra': 'pendent que {user} pagui la factura',
    'chat.payed': '{user} ha pagat la factura',
    'chat.payedExtra': '{user} ha pagat la factura',
    'chat.acceptedByppay': '{user} ha acceptat el byppay',
    'chat.acceptedByppayExtra': 'Pendent convidar l\'altre participant del byppay',
    'chat.rejectedByppay': '{user} ha rebutjat el byppay',
    'chat.rejectedByppayExtra': '{user} ha rebutjat el byppay',
    'chat.byppayPayed': 'Byppay pagat',
    'chat.byppayPayedExtra': 'Byppay pagat',
    'chat.invoiceGenerated': 'S\'han generat les factures compensades.',
    'chat.invoiceGeneratedExtra': '{user} és el propietari de la nova factura',
    'chat.acceptPaymentOutsidePlatform': 'Acceptar pagament fora de la plataforma',
    'chat.acceptPaymentOutsidePlatformExtra': 'Pagament fet i acceptat fora de la plataforma, factura finalitzada',
    'chat.paymentOutsidePlatform': 'Pagament fora de la plataforma ',
    'chat.paymentOutsidePlatformExtra': 'El receptor de la factura ha d\'acceptar el pagament fet fora de la plataforma',
    'chat.ButtonAcceptPaymentOutsidePlatform': 'Acceptar pagament fora de la plataforma',
    'chat.newDate': '{day}/{month}/{year}',
    'cat.nopaymentmethods': 'No hi ha metodes de pagament',
    'chat.set-payment': '{user} ha introduït els metodes de pagament',
    'chat.set-paymentExtra': 'Pendent que {payer} pagui o byppagui la factura',
    'chat.see-invoice': 'Veure factures',
    'chat.see-files': 'Veure fitxers',
    'chat.edit-payment-info': 'Modificar informació de pagament',
    'chat.view-contract': 'Veure contracte',
    'chat.stipe-public-key': 'Clau publica de Stripe',
    'chat.stipe-private-key': 'Clau privada de Stripe',
    'chat.public-crypto-address': 'Adreça pública Crypto',
    'chat.remind-introduce-payment-methods': 'Remind introduce payment methods',
    'chat.remind-paymentMethod': '{user} Remind introduce payment methods',
    'chat.remind-paymentMethodExtra': 'Esperant que {payer} introdueixi els mètodes de pagament',
    'chat.invoice-added': '{user} ha afegit una factura',
    'chat.invoice-addedExtra': 'Pendent d\'entrar mètodes de pagament del receptor {receiver}',
    'chat.byppay-added': '{user} ha afegit un byppay',
    'chat.byppay-addedExtra': 'Pendent de ser acceptat per {receiver}',
    'chat.remind-to-pay': 'Recordatorio pago',
    'chat.remind-to-payExtra': '{user} envia un recordatori de pagament a {payer}',
    'chat.file-input': 'Pujar fitxer',
    'chat.add-file': 'Afegir fitxer',
    'chat.noInvoiceInChat': 'No hi ha encara cap factura en el xat',
    'chat.remind-join-chat': 'Recordar unir-se al xat',
    'chat.insertMessage': 'Has d\'entrar un missatge',
    'chat.insertFile': 'Has d\'entrar un fitxer',
    'chat.archive-chat': 'Arxivar el xat',
    'chat.unarchive-chat': 'Desarxivar el xat',
    'chat.add-to-calendar': 'Afegir al Calendari',
    'Chat.helpCenter': 'Centre d\'ajuda',
    'Chat.Message': 'Missatge',
    'Chat.errorMessageHelp': 'Error al buscar missatge ajuda',
    'PaymentInformationBytton.AddPaymentMethod': 'Introdueix mètodes de pagament',


    'allFiles.files-in-invoice': 'Fitxers de la factura',
    'invoice.go-to-chat': 'Anar al xat',
    'invoice.acrhive': 'Arxivar',
    'invoice.archived': 'Desarxivar',
    'Invoice.Go Back': 'Tornar',
    'Invoice.Invoice Detail': 'Detall de la Factura',

    'createInvoice.nifReceiver': 'CIF/NIF del receptor',
    'createInvoice.nifPayer': 'CIF/NIF del pagador',

    'Login.LogoutUnregisteredUser': 'Tanca la sessió com a usuari no registrat',
    'Login.Forgot Password?': 'Has oblidat la contrasenya?',
    'Login.New to Byppay?': 'Nou a Byppay? ',
    'Login.Reset the Password!': 'Restableix la contrasenya!',
    'Login.Send email': 'Envia un correu electrònic',
    'Login.Change the Password!': 'Canvia la contrasenya!',
    'Login.New Password': 'Nova contrasenya',
    'Login.New Password Confirmation': 'Nova confirmació de la contrasenya',
    'Login.Change password': 'Canvia la contrasenya',
    'Login.Logged out succesfully!': 'Sessió tancada correctament',
    'Login.ERROR: Invalid token, check again the URL on your e-mail': 'ERROR: Token invàlid, revisa la URL del correu',
    'Login.ERROR: You are already validated': 'ERROR: Ja estàs validat',
    'Login.You let empty params, check it again please': 'Has deixat paràmetres buits: torna-ho a revisar, sisplau',
    'Login.Logged successfully!': 'Sessió iniciada correctament!',
    'Login.Check your email in order to reset the password': 'Comprova el teu correu electrònic per restablir la contrasenya',
    'Login.Error: Cannot send an email to reset you password. Please check the email you enter.': 'Error: no es pot enviar un correu electrònic per restablir la contrasenya. Comprova el correu electrònic que has introduït',
    'Login.You can now log in': 'Ara pots iniciar la sessió',
    'Login.Passwords doesn\'t match': 'Les contrasenyes no coincideixen',
    'Login.Register': 'Registrar-se',
    'Login.ERROR: Missing fields on the formulary': 'ERROR: Manquen camps en el formulari',
    'Login.ERROR: User not found': 'ERROR: Usuari no trobat',
    'Login.ERROR: Wrong password': 'ERROR: Contrasenya incorrecte',
    'Login.ERROR: User is not validated': 'ERROR: L\'usuari no està validat',
    'Login.about': 'Sobre byppay',
    'Login.LanguageTitle': 'Escull idioma',
    'Contact us': 'contacta\'ns',

    'Register.Your Name': 'El teu nom',
    'Register.Use 6 characters with a mix of letters, numbers & symbols': 'Utilitza 6 caràcters amb una combinació de lletres, números i símbols',
    'Register.Registered succesfully! Please check your email for the validation': 'Registre completat amb èxit! Revisa el teu correu per validar-te',
    'Register.ERROR: The user couldn\'t be saved': 'ERROR: L\'usuari no s\'ha pogut guardar',
    'Register.ERROR: E-mail already in use': 'ERROR: El correu ja està en ús',
    'Register.ERROR: CiF already in use': 'ERROR: El CIF ja està utilitzat',
    'Register.By signing up, you agree to Byppay of Use & Privacy Policy': 'Al registrar-te, accepta la',
    'Register.Policy': ' Política d\'ús i privacitat de Byppay',
    'Register.Already signed up? ': 'Ja estàs registrat? ',

    'AllFilesChat.notImages': 'Encara no hi ha cap imatge en el xat',
    'AllFilesChat.pdfs': 'Encara no hi ha cap pdf en el xat',
    'AllFilesChat.images': 'Imatges',
    'AllFilesChat.head': 'Fitxers en el xat ',
    'AllFilesChat.headGroup': 'Fitxers en el grup ',
    'chat.pdf': 'Veure contracte',
    'chat.download': 'Descarregar contracte com a pdf',

    'BrowseScroll.head': 'Factura número ',
    'BrowseScroll.undefined': 'indefinida',
    'BrowseScroll.DATA': 'DADES',

    'Button.accept': 'Accept',

    'InvoiceChats.registeredError': 'Has d\'estar registrat per utilitzar aquesta funció',
    'invoiceChats.Archived': 'Veure xats arxivats',
    'InvoiceChatsArchived.noChats': 'No hi ha cap xat arxivat encara',
    'InvoiceChatsArchived.returnToChats': 'Tornar als xats',
    'InvoiceChatsArchived.head': 'Aquests xats estàn arxivats actualment. Per desarxivar-los entreu al xat',
    'InvoiceChats.MessagePresentation': 'Missatge presentació Byppay',
    'InvoiceChats.There are no chats created yet': 'No hi ha xats creats encara',
    'InvoiceChats.Welcome back': 'Benvingut!',
    'InvoiceChats.InviteContacts': 'Pagueu les vostres factures o rebeu pagaments amb el botó "+".',
    'InvoiceChats.Foto': 'Foto',

    'Notifications.Notification List': 'Llista de notificacions',
    'Notifications.Error get notifications': 'Error l\'aconsegir les notificacions',

    'AllInvoicesChat.headGroup': 'Llista de factures en el xat',

    'Profile.Logged out succesfully!': 'Sessió tancada correctament!',
    'Profile.Profile': 'Perfil',
    'Profile.Name': 'Nom',
    'Profile.Surname': 'Cognoms',
    'Profile.Address': 'Adreça',
    'Profile.Country': 'País',
    'Profile.Wallet Address': 'Adreça de la cartera',
    'Profile.Exange ratios': 'Profile.Exange ratios',
    'Profile.Euro to byto ratio': 'Profile.Euro to byto ratio',
    'Profile.Platform amount': 'Total de la plataforma',
    'Profile.Don\'t show the splash screen at the beggining': 'No mostrar la pantalla de presentació a l\'inici',
    'Profile.Do you want to logout?': 'Vols tancar sessió?',
    'Profile.Payer comission': 'Descompte del pagador',
    'Profile.My profile': 'El meu perfil',

    'Create.Invoices': 'Factures de:',
    'Create.Status': 'Estat',
    'Create.days': 'dies',
    'Create.Invoice deleted successfully!': 'La factura s\'ha eliminat amb èxit',
    'Create.Error deleting the invoice': 'Error a l\'eliminar la factura',

    'InvoiceStatus.Payed': 'Pagada',
    'InvoiceStatus.Pending': 'Pendent',
    'InvoiceStatus.Unpayed': 'No pagada',
    'InvoiceStatus.Charged': 'Cobrada',
    'InvoiceStatus.Created': 'Creat',
    'InvoiceStatus.Compensated': 'Compensat',
    'InvoiceStatus.Temporary': 'Temporary',
    'InvoiceStatus.Unknown': 'Desconegut',
    'InvoiceStatus.ERROR: Cannot get blockChain data': 'ERROR: No s\'ha pogut obtenir les dades de la BlockChain',

    'InvoiceInformation.BlockChain Information': 'Informació de la BlockChain',
    'InvoiceInformation.Basic Information': 'Informació Bàsica',
    'InvoiceInformation.Link to Blockchain': 'Enllaç a la BlockChain',
    'InvoiceInformation.Blockchain Amount': 'Import de la BlockChain',
    'InvoiceInformation.Blockchain Date': 'Data de la BlockChain',
    'InvoiceInformation.Blockchain Status': 'Estat de la Blockchain',
    'InvoiceInformation.BlockChain': 'Blockchain',
    'InvoiceInformation.See transaction': 'Veure transacció',
    'InvoiceInformation.There is no data for this invoice stored on the Blockchain.': 'No hi ha cap dada sobre aquesta factura a la BlockChain.',

    'CreateInvoiceModal.NEW INVOICE': 'NOVA FACTURA',
    'CreateInvoiceModal.MODIFY INVOICE': 'MODIFICAR FACTURA',

    'SpecificCompensation.Pending Compensations': 'Compensacions Pendents',

    'Bypaysummary.Compensated': 'Compensada',

    'SmallInvoce.Me': 'Jo',

    'FactoringLogic.Petition modified successfully!': 'La petició ha estat modificada amb èxit!',

    'PendingFactoringItem.Do you want to accept this bypay?': 'Estàs segur d\'acceptar aquest byppay?',
    'PendingFactoringItem.Petition accepted successfully!': 'La petició ha estat acceptada amb èxit!',
    'PendingFactoringItem.USER NOT LOGGED!': 'BENVINGUT A BYPPAY',
    'PendingFactoringItem.You are not logged into the platform, please login or register to perform some action': 'Si us plau, fes login o registra’t per gestionar la compensació de factures',

    'SuggestedFactoringItem.DESTINY EMAILS': 'E-MAILS DESTÍ',
    'SuggestedFactoringItem.Do you want to propose your partners this bypay?': 'Vols proposar aquest byppay al client i al proveïdor?',
    'SuggestedFactoringItem.already exists, use another email!': ' ja existent, utilitza\'n un altre!',
    'SuggestedFactoringItem.Are you sure?': 'Estàs segur?',
    'SuggestedFactoringItem.Do you want to decline this bypay proposal?': 'Vols rebutjar aquesta proposta de byppay?',
    'SuggestedFactoringItem.The platform suggests you to perform the following compensation:': 'La plataforma us suggereix que realitzeu les compensacions següents',

    'InvoiceMissingInformation.Payer CIF': 'CIF del pagador',
    'InvoiceMissingInformation.Payer email:': 'Correu electrònic del pagador',
    'InvoiceMissingInformation.Payer email': 'Email del pagador',
    'InvoiceMissingInformation.Receiver CIF': 'CIF del receptor',
    'InvoiceMissingInformation.Receiver email': 'Email del receptor',
    'InvoiceMissingInformation.Receiver NIF/CIF, Mail & name': 'NIF/CIF, Mail & nom del receptor',
    'InvoiceMissingInformation.Payer NIF/CIF, Mail & name': 'NIF/CIF, Mail & nom del pagador',
    'InvoiceMissingInformation.Account number:': 'Número de compte:',
    'InvoiceMissingInformation.Update': 'Actualitza',

    'MyInvoices.PublishAMM': 'Vols publicar el Byppay al AMM i cobrar el seu cost',
    'MyInvoices.CollectByppay': 'Collect Byppay',
    'AmmModal.MessageInformation': 'Per poder cobrar el byppay a traves de l\'AMM fa falta pagar un premium amb un cost de:',
    'AmmModal.ValueToPay': 'Valor a pagar',


    'Help.HELP': 'AJUDA',
    'Help.Forward': 'Es realitza Forward',
    'Help.when you propose your providers if they want to be paid directly from your clients.': 'quan proposis als teus proveïdors si volen ser pagats directament pels teus clients',
    'Help.Bypay': 'Es realitza Byppay',
    'Help.when you ask your clients to pay your providers or when you want any client of your client to pay directly': 'quan proposis als teus clients pagar als teus proveïdors o bé quan vulguis que qualsevol client dels teus clients et pagui directament',
    'Help.If you are owner of a small business or self-employed': 'Si ets propietari d\'un petit negoci o autònom',
    'Help.Bypaying and forwarding invoices saves valuable cash and cash-in time, frees you from bank loans, and enhances your scoring': 'Fer Byppay o Forward de factures t\'estalvia temps i diners en efectiu, t\'allibera de préstecs bancaris i millora el teu scoring bancari',
    'Help.It is way cheaper than banks, safer, faster, and requires no burocracy thanks to the blockchain technology': 'És menys costós que els bancs, més segur, més ràpid i no té burocràcia gràcies a la tecnologia Blockchain',
    'Help.Try it! Byppay': 'Prova-ho! Byppay',


    "admin.NETWORK_ERROR": 'Xarxa incorrecte.',
    "admin.Comissions": 'Comissions de la plataforma',
    "admin.EditableMessages": 'Editar missatges',
    "admin.Exchange": 'Gestionar exchange',

    "exchange.NoTransactions": 'No hi ha transaccions',
    "EditableSystemMessages.Save Tag": "Guardat",

    "faucet.AddFunds": "Afegir diners",

    'Pay': 'Pagar',
    'CANCEL': 'CANCEL·LAR',
    'or': 'o',
    'NIE/NIF': 'NIE/NIF',
    'Password': 'Contrasenya',
    'LOG IN': 'INICIAR SESSIÓ',
    'SIGN UP': 'REGISTRAR-SE',
    'ERROR: Something went wrong': 'ERROR: Qualque cosa no ha funcionat',
    'E-mail': 'Correu Electrònic',
    'Phone number': 'Número de telèfon',
    'Back': 'Enrere',
    'Save': 'Guardar',
    'From:  ': 'De:  ',
    'To:': 'A:',
    'Logout': 'Tancar sessió',
    'Already exists a user with this CIF': 'Ja existeix un usuari amb aquest CIF',
    'Already exists a user with this Email': 'Ja existeix un usuari amb aquest correu',
    'Amount': 'Quantitat',
    'AMOUNT': 'QUANTITAT',
    'Outstanding Amount': 'Import Pendent',
    'DATE': 'DATA',
    'Date': 'Data',
    'Delay': 'Retràs',
    'Payer': 'Pagador',
    'Receiver': 'Receptor',
    'Cancel': 'Cancel·lar',
    'OK': 'D\'acord',
    'The invoice number you have entered already exists': 'El número de la factura introduït ja existeix!',
    'The phone must be valid': 'El telèfon ha de ser vàlid',
    'The mail must be valid.': 'El correu ha de ser vàlid',
    'This certificate reflects the agreement executed by the three parties': 'Aquest certificat reflecteix l\'acord executat per totes tres parts',
    ' will pay an amount of ': ' pagarà una quantitat de ',
    'Factoring information:': 'Informació del Byppay',
    'Compensation': 'Compensació',
    'Payer invoice:': 'Factura del Pagador:',
    'Receiver invoice:': 'Factura del Destinatari:',
    'Please enter the email of the user: ': 'Siusplau introdueix el correu electrònic de l\'usuari: ',
    'Tell me what type of invoice is': 'Diga\'m quin tipus de factura és',
    'Success changing the payment status': 'Èxit al canviar l’estat del pagament',
    'Error changing the payment status': 'Error al canviar l’estat del pagament',
    'Close': 'Tancar',
    'CLOSE': 'TANCAR',
    'View transaction': 'Veure transacció',
    'ConfirmationModal.Yes': 'Sí',
    'The value field is required': 'El camp valor és obligatori',
    'The phone field is required': 'El camp del telèfon és obligatori',
    'Comission must be greater than 0': 'La comissió ha de ser major que 0',
    'Sent': 'Clients',
    'Received': 'Proveïdors',
    'Petition rejected': 'Petició rebutjada',
    'Remaining to pay:': 'Roman per pagar: ',
    'Remaining to receive:': 'Roman per cobrar: ',
    'Waiting for your partner': 'Esperant a l’altre part',
    'Your partner': 'El teu client',
    'is asking you to simplify the next invoices:': 'us demana que compenseu les factures següents:',
    'User': 'Usuari',
    'offers you to change the next invoice:': 't\'ofereix compensar aquesta factura:',
    'offers to pay you the next invoice:': 's\'ofereix a pagar-te aquesta factura:',
    'No more payments required!': 'No calen més pagaments!',
    'You pay': 'Pagaràs',
    'to': 'a',
    'will pay': 'pagarà',
    'You receive': 'Tu reps',
    'from': 'de',
    'to accept or deny this bypay.': 'per acceptar o rebutjar aquest byppay.',
    'has denied this bypay.': 'ha denegat aquest byppay.',
    'This bypay has been approved by': 'Aquest byppay ha estat aprovat per',
    'all': 'totes',
    'partners!': 'les parts!',
    'Accepted': 'Acceptada',
    'COMPARATIVE INVOICES': 'COMPARACIÓ FACTURES',
    'INVOICE NUMBER ': 'NÚMERO DE FACTURA ',
    'New Payer: ': 'Nou Pagador: ',
    'New Receiver: ': 'Nou Receptor: ',
    'New Amount: ': 'Nova quantitat: ',
    'Catalan': 'Català',
    'Spanish': 'Castellà',
    'English': 'Anglès',
    'Accept': 'Accept',
    'Confirm': 'Confirmar',

    'Number:': 'Número: ',
    'Payer CIF:': 'CIF del Pagador: ',
    'ShowInvoiceInformation.New Payer cif: ': 'Nou CIF del Pagador: ',
    'Receiver CIF:': ' CIF del Receptor: ',
    'ShowInvoiceInformation.New Receiver cif: ': 'Nou CIF del Receptor: ',
    'Download': 'Descarrega',
    'DOWNLOAD': 'DESCARREGA',
    'ERROR: The invoice couldn\'t be saved, try again': 'ERROR: La factura no ha pogut ser guardada; intenta-ho un altre cop',
    'ERROR: Invoice number already exists': 'ERROR: El número de la factura ja existeix',
    'Saved successfully!': 'Guardada amb èxit',
    'Error paying invoice': 'Error al pagar la factura',
    'Invoice payed successfully!': 'La factura ha estat pagada amb èxit',
    'Do you want to delete this invoice?': 'Estàs segur d\'esborrar aquesta factura?',
    'Confirmation': 'Confirmació',
    'Refreshing...': 'Refrescant...',
    'Refreshing..': 'Refrescant..',
    'My NIF/CIF': 'El meu NIF/CIF',
    'INVOICE NUMBER': 'NÚMERO DE FACTURA',
    'Invoice Number': 'Número de Factura',
    'Missing Data': 'Falta informació',
    'Login': 'Iniciar Sessió',
    'Client': 'Client',
    'Upload Invoice': 'Introdueix Factura',
    'CLIENT': 'CLIENT',
    'Account number': 'Número de compte',
    'ACCOUNT NUMBER': 'NÚMERO DE COMPTE',
    'is going to pay this invoice to you by asking his client to do it: ': 'et pagarà aquesta factura proposant al seu client el fer-ho',
    'EMAIL': "CORREU ELECTRÒNIC",
    'You must enter the email of the ': 'Has d\'entrar el correu electrònic del ',
    'receiver!': 'receptor!',
    'payer!': 'pagador!',
    'You not have Candidates!': 'No tens cap factura candidata disponible!',
    'Participant': 'Participant',
    'GO': 'Endavant',
    'Email': 'Correu electrònic',
    'Upload Candidate': 'Afegeix una Candidata',
    'Due Date': 'Termini',
    'Rossum have detected the next information:': 'Rossum ha detectat la següent informació:',
    'Do you want to import?(in the next screen you can modify the fields)': "Vols importar? (A la pantalla següent pots modificar els camps)",
    'Import information?': 'Importa informació?',
    'Click on the contact to send the message via SMS and check the box': 'Fes clic al contacte per enviar el missatge via SMS i marca la casella',
    'Click on the contact to send the message via Whatsapp and check the box': 'Fes clic al contacte per enviar el missatge via Whatsapp i marca la casella',
    'Phone of ': 'Telèfon de ',
    'Notification options': 'Opcions per Notificar',
    'How do you want to notify compensation?': 'Com vols notificar la compensació?',
    'is a platform that facilitates payments to providers through potential customers in a fast, economical and secure way': 'és una plataforma que facilita el pagament a proveïdors a través dels clients potencials d’una manera ràpida, econòmica i segura',
    'UPLOAD INVOICE': 'PUJAR FACTURA',
    'Register to byppay.com': 'Registra\'t a byppay.com',
    'PAY YOUR INVOICES WHEN NO CASH': 'PAGA LES SEVES FACTURES QUAN NO HI HA EFECTIU',
    'Dark': 'Fosc',
    'Log in': 'Iniciar sessió',
    'Sign Up': 'Registrar-se',
    'Facebook Log in': 'Inici de sessió amb Facebook',
    'Google Log in': 'Inici de sessió amb Google',
    'I am waiting for your decision. Please go to this link to make an action: ': 'Estic esperant la teva decisió. Visita l\'enlaç per realizar una acció:',
    'In order to do this option you need to login, Do you want to login?': 'Per fer aquesta opció has d’iniciar sessió: vols iniciar-la?',
    'RECEIVER INVOICE': 'FACTURA DEL RECEPTOR',
    'To pay': 'Pagar',
    '|Policies': '|Polítiques',
    'Outstanding amount': 'Import pendent',
    'Delete': 'Eliminar',
    '+ Add Contact': '+ Afegir Contacte',
    'OUTSTANDING AMOUNT': 'QUANTITAT PENDENT',
    'Certificate number': 'Número certificat',
    'Debtor (A)': 'Deutor (A)',
    'Creditor (B)': 'Acreedor (B)',
    'Beneficiary (C)': 'Beneficiari (C)',
    'Manifested agreement': 'Resum de l\'acord de byppay',
    'Payment Accepted': 'Pagament acceptat',
    'Record a video for your partners': 'Grava un video per convidar al byppay',
    'Skip': 'Saltar',
    'NotificationTypesForCompensate.DON\'T NOTIFICATE': 'No notifiquis',
    'Quantity that A deduces from his debt with B through a payment to C': 'Quantitat que A dedueix del seu deute amb B mitjançant un pagament a C',
    'Payment from debtor (A) to beneficiary (C)': 'Pagament del deutor (A) al beneficiari (C)',
    'To the following account': 'Al següent compte',
    'From': 'De',
    'To': 'Per',
    'Add liquidity': 'Afegir liquiditat',
    'Message Add Liquidity': 'Quantitat de líquid a aportar',
    'Payment with stripe:': 'Pagament amb stripe:',
    'Error.User not found': 'Usuari no trobat',
    'Error.Something went wrong': 'Qualque cosa no ha funcionat',
    'Pay with crypto': 'Pagar amb criptomonedes',
    'I payed outside of platform': 'He pagat fora de la plataforma',
    'CompensationSteper.Select allowed payment methods': 'Selecciona els mètodes  de pagament',
    'Error: pay collateral': 'Error al pagar els collaterals',
    'Collateral payed': 'Collateral pagat',
    'payProvider': 'You will use a client\'s invoice to pay up to {invoicePrice} € to this provider. Proceed?',

    'Amount:': 'Quantitat:',
    'Error.Error deleting bypay': 'Error a l\'eliminar el byppay',
    'Error.Error accepting petition': 'Error a l\'acceptar la petició',
    'Error.Error modifying petition': 'Error al modificar la petició',
    'Error.The mail field is required': 'El camp email és obligatori',
    'Error.Error rejecting petition': 'Error al rebutjar la petició',
    'Error.This field is required': 'Aquest camp és obligatori',
    'Error.The CIF must be different than yours.': 'El CIF ha de ser diferent que el teu.',
    'Error.The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)': 'El CIF ha de ser vàlid (Formats d\'exemple: A12345678, 12345678B, C1234567D)',

    'Success.Bypay deleted successfully!': 'El byppay s\'ha esborrat amb èxit.',
    'EditContact.SAVE': 'Guardar',
    'RelatedInvoice': 'Factura relacionada',


    'error.NoMoney': 'Et falten diners per pagar.',
    'error.NoMoney.Faucet': 'Anar a la faucet',
    'error.NoWallet': 'No tens un criptomonader configurat.',
    'error.NoWallet.Video': 'Anar al video explicatiu',

    'LandingPage.WelcomeMessage1': 'Benvingut a Byppay,',
    'LandingPage.WelcomeMessage2': 'la més ràpida i assequible solució per pagar factures.',
    'LandingPage.NoAccount': 'No estàs registrat encara?',
    'LandingPage.Start': 'Comencem!',
    "Exchage": "Canvi de divises",
    "Send": "Pagar factura",
    "Receive": "Cobrar factura",
    "notifications": "Notificacions",
    "What we do?": "Què fem?",
    "Settings": "Configuració",
    'tutorial.welcomeToByppay': 'Benvinguts a Byppay!',
    'tutorial.Tell': 'T\'expliquem totes les seves funcionalitats.',
    'tutorial.discoverbtn': 'Descobreix com utilitzar-lo',
    'tutorial.skipbtn': 'Saltar tutorial',
    'tutorial.text1': 'Les explicacions estaran disponibles en tot moment per ajudar-te en el camí.',
    'tutorial.text2': 'Mira aquest vídeo per tenir una millor idea dels propers passos a seguir.',
    'tutorial.nextbtn': 'Següent',
    'tutorial.text3': 'Byppay és una aplicació web que permet pagar les factures 4 vegades més barat i x10 més ràpid.',
    'tutorial.text4': 'Mira aquest vídeo per conèixer la navegació dins de l\'aplicació.',
    'tutorial.text5': 'Byppay et permet pagar, byppagar o cobrar les teves factures, depenent de la vostra situació.',
    'tutorial.text6': 'Vols saber més sobre el punt de vista del client o del proveïdor?',
    'tutorial.text65': 'Si vols saber més sobre el punt de vista del client, fes clic a "Vull que em paguin a les meves factures".',
    'tutorial.text7': 'Si vols rebre el pagament de les teves factures pendents, mira aquest vídeo per entendre millor el punt de vista del proveïdor.',
    'tutorial.text8': 'Si vols pagar o byppagar les teves factures pendents,mira aquest vídeo per entendre millor el punt de vista del client o contractista.',
    'tutorial.paybtn': 'Vull pagar les meves factures',
    'tutorial.getpaidbtn': 'Vull que em paguin les factures',
    'tutorial.endtutorial': 'Acabar tutorial',

    'Popup.verify': 'Verifica el teu compte',
    'Formulary.AddContact': 'Afegeix contacte',
    'Formulary.ChooseAContact': 'Escull contacte',
    'Formulary.Contact Name': 'Nom',
    'Formulary.Contact NIF/CIF': 'NIF/CIF',
    'Formulary.Contact Email': 'Email',
    'Formulary.Contact phone': 'Telèfon',

    'Working.onIt' : 'Hi estem treballant',
    'We.are Working' : 'Estem treballant en aquesta funció!'
};

